module.exports = __webpack_public_path__ + "static/img/sj.e353a64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img/sj.png
// module id = yaA0
// module chunks = 0